query getNumberOfLandingpages {
  numberOfLandingpages: getNumberOfLandingpages
}
